module.exports = __webpack_public_path__ + "img/icon4.5a7c8a19.png";